import { Button } from '@crowdex/ui/components/button';
import { ArrowLeft } from 'lucide-react';
import { useRef } from 'react';
import { useThreadSummaryRender } from '@/components/desktop-shell/thread-summary';
import { useSwipeBack } from './use-swipe-back';

/**
 * The conversation's Summary on a phone (mobile 36): a page pushed over the conversation, not a
 * sheet, titled "← Summary", with the summary's sections (Code, Runs in, Artifacts,
 * Sources, Wakes on) as the desktop's card shows them. Its ← and the phone's back pop it. The
 * shell already keeps clear of the notch and the home indicator.
 */
export function MobileSummaryPage({ onBack }: { onBack: () => void }) {
  const render = useThreadSummaryRender();
  const screenRef = useRef<HTMLElement>(null);
  useSwipeBack(screenRef, onBack, true, { fromAnywhere: true });
  return (
    <section
      aria-label="Summary"
      className="absolute inset-0 z-40 flex flex-col bg-background"
      data-mobile-summary
      ref={screenRef}
    >
      <header className="flex h-14 shrink-0 items-center gap-1 px-1">
        <Button aria-label="Back" onClick={onBack} size="icon" variant="ghost">
          <ArrowLeft className="size-5" />
        </Button>
        <h1 className="type-card-title flex-1 truncate pr-11 text-center">Summary</h1>
      </header>
      <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 pt-1 pb-6">
        {render?.(true)}
      </div>
    </section>
  );
}
